<template>
    <v-card class="grey lighten-3 d-flex align-center mx-auto" width="140px" height="40px" hover @click="$emit('edit')">
        <v-card-text class="text-center">
            <div class="caption">Set an action...</div>
            <!-- <div class="caption grey--text text--darken-1">(click to edit)</div> -->
        </v-card-text>
        <!-- <v-btn x-small fab absolute top right class="accent mr-n4 mt-1" @click="$emit('edit')" v-if="pencil">
            <v-icon size="11px">fa-pen</v-icon>
        </v-btn> -->
    </v-card>
</template>

<script>
export default {
    props: ['pencil']
}
</script>